function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "g1713",
  transform: "translate(8.485 -5.657) rotate(45)"
}, React.createElement("path", {
  id: "path1245",
  d: "M-239.46-110.08h20",
  transform: "translate(239.46 120.08)",
  fill: "none",
  stroke: "#09b0ee",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), React.createElement("path", {
  id: "path1709",
  d: "M-151.568-197.971v20",
  transform: "translate(161.568 197.971)",
  fill: "none",
  stroke: "#09b0ee",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16.971,
    height: 16.97,
    viewBox: "0 0 16.971 16.97"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/closev2.c5af851c.svg";
export { SvgComponent as ReactComponent };